import { safeLocalStorage } from "../../utils/safeStorage";
const WORKSPACE_ID_KEY = "workspaceId";
const TENANT_ID_KEY = "tenantId";

/** Returns the stored workspace id, or null if the user has not selected / logged into one. */
export const tryGetActiveWorkspaceId = (): string | null =>
  safeLocalStorage.getItem(WORKSPACE_ID_KEY);

export const getActiveWorkspaceId = (): string => {
  const id = tryGetActiveWorkspaceId();
  if (!id) {
    throw new Error("No active workspace — please log in again.");
  }
  return id;
};

export const getActiveTenantId = (): string | null =>
  safeLocalStorage.getItem(TENANT_ID_KEY);

/** Persist the tenant selected from the authenticated membership list. */
export const setActiveTenantId = (tenantId: string): void => {
  safeLocalStorage.setItem(TENANT_ID_KEY, tenantId);
};

export const setActiveWorkspace = ({
  workspaceId,
  tenantId,
}: {
  workspaceId: string;
  tenantId: string | null;
}): void => {
  safeLocalStorage.setItem(WORKSPACE_ID_KEY, workspaceId);
  if (tenantId) {
    safeLocalStorage.setItem(TENANT_ID_KEY, tenantId);
  }
};

/** Clear a workspace whenever its parent tenant changes or becomes invalid. */
export const clearActiveWorkspaceId = (): void => {
  safeLocalStorage.removeItem(WORKSPACE_ID_KEY);
};

export const clearActiveWorkspace = (): void => {
  safeLocalStorage.removeItem(WORKSPACE_ID_KEY);
  safeLocalStorage.removeItem(TENANT_ID_KEY);
};
